import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import { Link } from "react-router-dom";
import styles from "./Blog2.module.css";
import SEO from "../../SEO";

const BASE_URL = "https://ecom.cyberathon.com";

function Blog2() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
const [seoData, setSeoData] = useState({});
  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/index.php/Api/list_blog`);
      if (res.data.status) {
        setBlogs(res.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/index.php/Api/get_seo_by_page`, { page_name: 'blog' });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  return (
    <>
    <SEO
    title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
    description={seoData.description || "ShopIndia is the best online shopping platform..."}
    keywords={seoData.keywords || "ShopIndia, online shopping, electronics, clothes, medicines"}
    canonical={seoData.canonical || "https://www.shopindia.com/"}
  />
      <Layout />

      <div className={styles.bh}>
         <h2 className="text-center text-bold fw-bold pt-5 ">Blogs</h2>
        <div className={styles.blogPage}>

          {/* ── Hero Header ── */}
          {/* <div className={styles.blogHero}> */}
            {/* <p className={styles.blogSubheading}>Our Latest</p>
            <h2 className={styles.blogHeading}>Blogs &amp; Articles</h2>
            <div className={styles.headingAccent}>
              <span className={styles.headingAccentDot}></span>
            </div> */}
           
          {/* </div> */}

          {/* ── Grid: 3 cards per row on desktop ── */}
          <div className={`container-fluid ${styles.blogGrid}`}>
            <div className="row g-4">

              {/* Loading Skeletons — 3 per row */}
              {loading &&
                Array.from({ length: 6 }).map((_, i) => (
                  <div className="col-12 col-sm-6 col-md-4" key={i}>
                    <div className={styles.skeletonCard}>
                      <div className={styles.skeletonImg} />
                      <div className={styles.skeletonLine} />
                      <div className={styles.skeletonLine} />
                      <div className={styles.skeletonLine} />
                    </div>
                  </div>
                ))}

              {/* Empty state */}
              {!loading && blogs.length === 0 && (
                <div className={styles.emptyState}>
                  No blogs found at the moment. Check back soon!
                </div>
              )}

              {/* Blog Cards — col-md-4 = 3 per row on ≥768px */}
              {!loading &&
                blogs.map((blog) => (
                  <div className="col-12 col-sm-6 col-md-4" key={blog.id}>
                    <div className={styles.blogCard}>

                      {/* Image — full image, not cropped */}
                      <div className={styles.imageWrapper}>
                        <img
                          src={`${BASE_URL}/${blog.image}`}
                          alt={blog.heading}
                          onError={(e) => {
                            e.target.src =
                              "https://placehold.co/800x500/edf6f6/24aeb1?text=No+Image";
                          }}
                        />
                      </div>

                      {/* Content */}
                      <div className={styles.blogContent}>
                        <h5>{blog.heading}</h5>
                        {/* <p>{blog.description}</p> */}
 <div className={styles.blogDesc}>
    {blog.description
      ?.replace(/<[^>]+>/g, "")
      .slice(0, 120)}...
  </div>
                        <div className={styles.cardFooter}>
                          <span className={styles.blogDate}>
                            {blog.day} {blog.month} {blog.year}
                          </span>

                          <Link to={`/blog/${blog.id}`} className={styles.gol}>
                            <i className="bi bi-arrow-left"></i>
                          </Link>
                        </div>
                      </div>

                    </div>
                  </div>
                ))}

            </div>
          </div>
        </div>

        <FooterNew />
      </div>
    </>
  );
}

export default Blog2;